import React, { useState, useEffect } from 'react'; 
import { 
  Button, Container, Typography, Box, TextField, Paper, Snackbar, Alert, 
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, IconButton , FormControl, InputLabel, Select, AppBar, Toolbar, Menu, MenuItem
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { api } from '../services/api';
import { Download, PictureAsPdf, Edit, Delete } from '@mui/icons-material';
import * as XLSX from 'xlsx'; 
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useNavigate } from 'react-router-dom';

const isAuthenticated = !!localStorage.getItem('token'); 


export default function AdminPage() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [file, setFile] = useState(null);
  const [notify, setNotify] = useState({ open: false, message: '', severity: 'success' });

  const [cultivo, setCultivo] = useState('');
  const [analito, setAnalito] = useState('');
  const [codexLmr, setCodexLmr] = useState('');
  const [codexCodigo, setCodexCodigo] = useState('');
  const [listaunicaFuente, setListaUnicaFuente] = useState('');
  const [listaunicaCodigo, setListaUnicaCodigo] = useState('');
  const [nacionalLmr, setNacionalLmr] = useState('');
  const [nacionalCodigo, setNacionalCodigo] = useState('');
  const [epaLmr, setEpaLmr] = useState('');
  const [epaCodigo, setEpaCodigo] = useState('');
  const [ueLmr, setUeLmr] = useState('');
  const [ueCodigo, setUeCodigo] = useState('');
  const [tipoalimento, settipoalimento] = useState('');
  const [tiporesiduo, settiporesiduo] = useState('');
  const [unidad, setunidad] = useState('');
  const [codigo, setcodigo] = useState('');

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [rowToEdit, setRowToEdit] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const [busqueda, setBusqueda] = useState('');
const [seleccionados, setSeleccionados] = useState([]);
const [deleteGroupOpen, setDeleteGroupOpen] = useState(false);

const [todosAnalitosAdmin, setTodosAnalitosAdmin] = useState([]);
const [sugerenciasAdmin, setSugerenciasAdmin]     = useState([]);
const [showSugAdmin, setShowSugAdmin]             = useState(false);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleStatsClick = () => {
    handleCloseMenu();
    navigate('/admin/stats');
  };



  const columns = [
    /*{ field: 'id', headerName: 'N°', width: 70 },*/
    { field: 'cultivo', headerName: 'Alimento', width: 100 },
    { field: 'analito', headerName: 'analito', width: 120 },
   
   
   
    {
      field: 'limite',
      headerName: 'Limite',
      width: 90,
      valueGetter: (value, row) =>
        row.codex_lmr ?? row.ue_lmr ?? row.nacional_lmr ?? row.epa_lmr ?? '',
    },
    { field: 'unidad', headerName: 'Unidad', width: 90 },
    {
      field: 'codigoMostrado',
      headerName: 'Codigo',
      width: 90,
      valueGetter: (value, row) =>
        row.codex_codigo ?? row.ue_codigo ?? row.nacional_codigo ?? row.epa_codigo ?? '',
    },
    {
      field: 'fuenteMostrada',
      headerName: 'Fuente',
      width: 120,
      valueGetter: (value, row) => row.fuente ?? '',
    },




    { field: 'tipoalimento', headerName: 'Tipo de alimento', width: 220 },
    { field: 'tiporesiduo', headerName: 'Tipo de residuo', width: 335 },
    {
      field: 'acciones',
      headerName: 'Acciones',
      width: 115,
      sortable: false,
      renderCell: (params) => (
        <Box display="flex" gap={1}>
          <IconButton 
            color="primary"
            onClick={() => openEditDialog(params.row)}
            title="Editar"
          >
            <Edit />
          </IconButton>
          <IconButton 
            color="error"
            onClick={() => openDeleteDialog(params.row)}
            title="Eliminar"
          >
            <Delete />
          </IconButton>
        </Box>
      ),
    },
  ];

  async function fetchData() {
    try {
      const response = await api.get('/data');
      setData(response.data);
    } catch (error) {
      console.error('Error al obtener los datos:', error);
    }
  }

  useEffect(() => {
    fetchData();
    api.get('/data/analitos')
      .then(res => { if (Array.isArray(res.data)) setTodosAnalitosAdmin(res.data); })
      .catch(() => {});
  }, []);

  async function handleUpload() {
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    try {
      await api.post('/data/upload', formData);
      setNotify({ open: true, message: 'Datos subidos correctamente', severity: 'success' });
      await fetchData();
    } catch (error) {
      console.error(error);
      setNotify({ open: true, message: 'Error al subir datos', severity: 'error' });
    }
  }

  async function handleAddRecord(e) {
    e.preventDefault();
    try {
      await api.post('/data', {
        cultivo,
        analito,
       // codex_lmr: codexLmr ? parseFloat(codexLmr) : null,
        codex_lmr: codexLmr,
        codex_codigo: codexCodigo,
        listaunica_fuente: listaunicaFuente,
        listaunica_codigo: listaunicaCodigo,
        nacional_lmr: nacionalLmr ? parseFloat(nacionalLmr) : null,
        nacional_codigo: nacionalCodigo,
        epa_lmr: epaLmr ? parseFloat(epaLmr) : null,
        epa_codigo: epaCodigo,
        ue_lmr: ueLmr ? parseFloat(ueLmr) : null,
        ue_codigo: ueCodigo,
        tipoalimento: tipoalimento,
        tiporesiduo: tiporesiduo,
        unidad: unidad,
        codigo: codigo
      });
      setNotify({ open: true, message: 'Registro agregado correctamente', severity: 'success' });
      setCultivo('');
      setAnalito('');
      setCodexLmr('');
      setCodexCodigo('');
      setListaUnicaFuente('');
      setListaUnicaCodigo('');
      setNacionalLmr('');
      setNacionalCodigo('');
      setEpaLmr('');
      setEpaCodigo('');
      setUeLmr('');
      setUeCodigo('');
      settipoalimento('');
      settiporesiduo('');
      setunidad('');
      setcodigo('');

      await fetchData();
    } catch (err) {
      console.error(err);
      setNotify({ open: true, message: 'Error al agregar registro', severity: 'error' });
    }
  }

  function openDeleteDialog(row) {
    setRowToDelete(row);
    setDeleteDialogOpen(true);
  }

  async function handleDelete() {
    if (!rowToDelete) return;
    try {
      await api.delete(`/data/${rowToDelete.id}`);
      setNotify({ open: true, message: 'Registro eliminado correctamente', severity: 'success' });
      await fetchData();
    } catch (err) {
      console.error(err);
      setNotify({ open: true, message: 'Error al eliminar registro', severity: 'error' });
    } finally {
      setDeleteDialogOpen(false);
      setRowToDelete(null);
    }
  }



  async function handleDeleteGroup() {
    if (seleccionados.length === 0) return;
    try {
      await Promise.all(seleccionados.map(id => api.delete(`/data/${id}`)));
      setNotify({ open: true, message: `${seleccionados.length} registros eliminados`, severity: 'success' });
      setSeleccionados([]);
      await fetchData();
    } catch (err) {
      console.error(err);
      setNotify({ open: true, message: 'Error al eliminar registros', severity: 'error' });
    } finally {
      setDeleteGroupOpen(false);
    }
  }




  function openEditDialog(row) {
    setRowToEdit(row);
    setEditDialogOpen(true);
  }

  async function handleEdit() {
    if (!rowToEdit) return;
    try {
      await api.put(`/data/${rowToEdit.id}`, rowToEdit);
      setNotify({ open: true, message: 'Registro actualizado correctamente', severity: 'success' });
      await fetchData();
    } catch (err) {
      console.error(err);
      setNotify({ open: true, message: 'Error al actualizar registro', severity: 'error' });
    } finally {
      setEditDialogOpen(false);
      setRowToEdit(null);
    }
  }

  function exportToExcel() {
    const filteredData = data.map((row) => ({
      Alimento: row.cultivo,
      Analito: row.analito,
      Limite: row.codex_lmr ?? row.ue_lmr ?? row.nacional_lmr ?? row.epa_lmr ?? '',
      Unidad: row.unidad,
      Codigo: row.codex_codigo ?? row.ue_codigo ?? row.nacional_codigo ?? row.epa_codigo ?? '',
      Fuente: row.fuente ?? '',
      Tipoalimento: row.tipoalimento,
      Tiporesiduo: row.tiporesiduo
    }));
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");
    XLSX.writeFile(workbook, "datos.xlsx");
  }

  
  function exportToPDF() {
    const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" }); 
  
    const pageWidth = doc.internal.pageSize.getWidth(); // ✅ Mover esto arriba
    const margin = 10;
    const usableWidth = pageWidth - margin * 2;
    const titleStartY = 5; // puedes ajustar si lo usas luego

   
    doc.text("Reporte de Datos", pageWidth / 2, titleStartY + 14, { align: "center" });
  
    // Generar la tabla con datos
    const tableStartY = titleStartY + 22;
  
    const columnsForPDF = [
      { header: "Alimento", dataKey: "cultivo" },
      { header: "Analito", dataKey: "analito" },
      { header: "Límite", dataKey: "limite" },
      { header: "Unidad", dataKey: "unidad" },
      { header: "Codigo/Documento", dataKey: "codigoMostrado" },
      { header: "Fuente", dataKey: "fuente" },
      { header: "Tipo de alimento", dataKey: "tipoalimento" },
      { header: "Tipo de residuo", dataKey: "tiporesiduo" },
    ];

    const bodyForPDF = data.map((row) => ({
      ...row,
      limite: row.codex_lmr ?? row.ue_lmr ?? row.nacional_lmr ?? row.epa_lmr ?? '',
      codigoMostrado: row.codex_codigo ?? row.ue_codigo ?? row.nacional_codigo ?? row.epa_codigo ?? '',
      fuente: row.fuente ?? '',
    }));
  
    doc.autoTable({
      columns: columnsForPDF,
      body: bodyForPDF,
      startY: tableStartY,
      styles: {
        fontSize: 7,              // 👈 Reducir tamaño de fuente
        cellPadding: 1,
        halign: "center",
      },
      headStyles: {
        fillColor: [70, 130, 180], // Azul más oscuro para los encabezados
        textColor: [255, 255, 255], // Texto blanco
        fontSize: 8,
      },
      columnStyles: {
        cultivo: { cellWidth: 28 },
        analito: { cellWidth: 28 },
        limite: { cellWidth: 16 },
        unidad: { cellWidth: 16 },
        codigoMostrado: { cellWidth: 54 },
        fuente: { cellWidth: 26 },
        tipoalimento: { cellWidth: 51 },
        tiporesiduo: { cellWidth: 54 },
      },
      margin: { left: margin, right: margin },
    });

   
    // Guardar el PDF
    doc.save("datos.pdf");
  }
  



  const dataFiltrada = data.filter(row => {
    if (!busqueda.trim()) return true;
    const q = busqueda.toLowerCase();
    const codigoRow = row.codex_codigo || row.ue_codigo || row.nacional_codigo || row.epa_codigo || '';
    return (
      (row.cultivo      || '').toLowerCase().includes(q) ||
      (row.analito      || '').toLowerCase().includes(q) ||
      (row.tipoalimento || '').toLowerCase().includes(q) ||
      (row.tiporesiduo  || '').toLowerCase().includes(q) ||
      (row.fuente       || '').toLowerCase().includes(q) ||
      codigoRow.toLowerCase().includes(q)
    );
  });






  return (
    <Container style={{ marginTop: '2rem' }}>

            <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        p: 2,
        border: '1px solid #ddd',
        borderRadius: 2,
        backgroundColor: '#f9f9f9',
        boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
        mb: 3,
        width: '100%',
        maxWidth: 1117,
        mx: 'auto',
        height: 'auto'
      }}>
        <Typography variant="h5" noWrap sx={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
          Subir registros masivos
        </Typography>

        <Typography
          variant="h7"
          noWrap
          sx={{
            flexGrow: 2,
            color: '#666',
            textAlign: 'right',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {file ? file.name : 'Ningún archivo seleccionado'}
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'left', gap: 2, width: '100%', maxWidth: 400 }}>
          <Button
            variant="outlined"
            component="label"
            sx={{
              flexGrow: 0,
              width: 280,
              textTransform: 'none',
              padding: '7px 12px',
            }}
          >
            Seleccionar archivo
            <input
              type="file"
              accept=".csv,.xlsx"
              onChange={(e) => setFile(e.target.files[0])}
              hidden
            />
          </Button>

          <Button
            variant="contained"
            onClick={handleUpload}
            color="primary"
            sx={{ whiteSpace: 'nowrap' }}
          >
            SUBIR ARCHIVO
          </Button>
        </Box>
      </Box>

      <Paper variant="outlined" style={{ padding: '1rem', marginBottom: '2rem' }}>
        <Typography variant="h6" gutterBottom>Agregar Nuevo Registro Manualmente</Typography>
        <form onSubmit={handleAddRecord}>
          <Box display="flex" flexWrap="wrap" gap={2}>
            <TextField label="Alimento" value={cultivo} onChange={e => setCultivo(e.target.value)} required />
            <TextField label="Analito" value={analito} onChange={e => setAnalito(e.target.value)} required />
            <TextField label="Limite" value={codexLmr} onChange={e => setCodexLmr(e.target.value)} required />
            <TextField label="Unidad" value={unidad} onChange={e => setunidad(e.target.value)}  />
            <TextField label="Código/Documento" value={codigo} onChange={e => setcodigo(e.target.value)}  />
            <TextField label="Fuente" value={codexCodigo} onChange={e => setCodexCodigo(e.target.value)}  />

            <FormControl fullWidth>
              <InputLabel id="tipo-alimento-label">Tipo de Alimento</InputLabel>
              <Select
                labelId="tipo-alimento-label"
                value={tipoalimento}
                onChange={(e) => settipoalimento(e.target.value)}
                required
              >
                <MenuItem value="ALIMENTOS DE ORIGEN VEGETAL">ALIMENTOS DE ORIGEN VEGETAL</MenuItem>
                <MenuItem value="ALIMENTOS DE ORIGEN ANIMAL">ALIMENTOS DE ORIGEN ANIMAL</MenuItem>
                <MenuItem value="PIENSOS E INGREDIENTES DE PIENSOS">PIENSOS E INGREDIENTES DE PIENSOS</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="tipo-residuo-label">Residuo/Contaminante</InputLabel>
              <Select
                labelId="tipo-residuo-label"
                value={tiporesiduo}
                onChange={(e) => settiporesiduo(e.target.value)}
                required
              >
                <MenuItem value="PLAGUICIDAS QUÍMICOS DE USO AGRÍCOLA">PLAGUICIDAS QUÍMICOS DE USO AGRÍCOLA</MenuItem>
                <MenuItem value="PLAGUICIDAS QUÍMICOS">PLAGUICIDAS QUÍMICOS</MenuItem>
                <MenuItem value="CRITERIOS MICROBIOLOGICOS">CRITERIOS MICROBIOLOGICOS</MenuItem>
                <MenuItem value="METALES PESADOS">METALES PESADOS</MenuItem>
                <MenuItem value="MICOTOXINAS">MICOTOXINAS</MenuItem>
                <MenuItem value="MEDICAMENTOS VETERINARIOS">MEDICAMENTOS VETERINARIOS</MenuItem>
              </Select>
            </FormControl>

            <Box display="flex" alignItems="center" gap={2}>
              <Button type="submit" variant="contained" color="primary">
                AGREGAR
              </Button>
              <Button variant="contained" color="secondary" onClick={exportToPDF} startIcon={<PictureAsPdf />}>
                PDF
              </Button>
              <Button variant="contained" color="success" onClick={exportToExcel} startIcon={<Download />}>
                EXCEL
              </Button>
            </Box>
          </Box>
        </form>
      </Paper>

     
      <Typography variant="h5" gutterBottom>Datos Existentes</Typography>

<Box display="flex" gap={2} mb={2} alignItems="center" flexWrap="wrap">
 
 
<Box sx={{ position: 'relative', flex: 1, minWidth: 280 }}>
  <TextField
    label="🔍 Buscar por alimento, analito, fuente..."
    value={busqueda}
    onChange={e => {
      const val = e.target.value;
      setBusqueda(val);
      const q = val.toLowerCase();
      if (q.length >= 1) {
        const sug = todosAnalitosAdmin
          .filter(a => a.toLowerCase().includes(q))
          .slice(0, 10);
        setSugerenciasAdmin(sug);
        setShowSugAdmin(sug.length > 0);
      } else {
        setShowSugAdmin(false);
      }
    }}
    onBlur={() => setTimeout(() => setShowSugAdmin(false), 200)}
    size="small"
    fullWidth
    InputProps={{
      endAdornment: busqueda && (
        <IconButton size="small" onClick={() => { setBusqueda(''); setShowSugAdmin(false); }}>
          <Delete fontSize="small" />
        </IconButton>
      )
    }}
  />
  {showSugAdmin && (
    <Box sx={{
      position: 'absolute', top: '100%', left: 0, right: 0,
      background: 'white', border: '1px solid #d1d5db',
      borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,.12)',
      zIndex: 1000, maxHeight: 220, overflowY: 'auto',
    }}>
      {sugerenciasAdmin.map(a => (
        <Box key={a}
          onMouseDown={() => { setBusqueda(a); setShowSugAdmin(false); }}
          sx={{
            padding: '8px 12px', fontSize: '.88rem', cursor: 'pointer',
            borderBottom: '1px solid #f3f4f6',
            '&:hover': { background: '#fff3e0', color: '#e65100' },
          }}
        >
          🧪 {a}
        </Box>
      ))}
    </Box>
  )}
</Box>


  {seleccionados.length > 0 && (
    <Button
      variant="contained"
      color="error"
      startIcon={<Delete />}
      onClick={() => setDeleteGroupOpen(true)}
    >
      Eliminar {seleccionados.length} seleccionado{seleccionados.length > 1 ? 's' : ''}
    </Button>
  )}
</Box>

<div style={{ height: 500, width: '100%' }}>
 
<DataGrid
  rows={dataFiltrada}
  columns={columns}
  pageSize={10}
  rowsPerPageOptions={[10, 25, 50]}
  checkboxSelection
  disableSelectionOnClick
  onRowSelectionModelChange={(ids) => setSeleccionados(ids)}
  rowSelectionModel={seleccionados}
/>



      </div>

      <Snackbar open={notify.open} autoHideDuration={3000} onClose={() => setNotify({ ...notify, open: false })}>
        <Alert onClose={() => setNotify({ ...notify, open: false })} severity={notify.severity} sx={{ width: '100%' }}>
          {notify.message}
        </Alert>
      </Snackbar>

      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Confirmar eliminación</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Está seguro que desea eliminar este registro?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancelar</Button>
          <Button onClick={handleDelete} color="error">Eliminar</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
      >
        <DialogTitle>Editar Registro</DialogTitle>
        <DialogContent>
          {rowToEdit && (
            <>
              <TextField
                label="Alimento"
                fullWidth
                margin="normal"
                value={rowToEdit.cultivo}
                onChange={(e) => setRowToEdit({ ...rowToEdit, cultivo: e.target.value })}
              />
              <TextField
                label="Analito"
                fullWidth
                margin="normal"
                value={rowToEdit.analito}
                onChange={(e) => setRowToEdit({ ...rowToEdit, analito: e.target.value })}
              />
              <TextField
                label="Limite"
                fullWidth
                margin="normal"
                value={rowToEdit.codex_lmr}
                onChange={(e) => setRowToEdit({ ...rowToEdit, codex_lmr: e.target.value })}
              />
                <TextField
                label="Unidad"
                fullWidth
                margin="normal"
                value={rowToEdit.unidad}
                onChange={(e) => setRowToEdit({ ...rowToEdit, unidad: e.target.value })}
              />
                <TextField
                label="Codigo"
                fullWidth
                margin="normal"
                value={rowToEdit.codigo}
                onChange={(e) => setRowToEdit({ ...rowToEdit, codigo: e.target.value })}
              />
              <TextField
                label="Fuente"
                fullWidth
                margin="normal"
                value={rowToEdit.codex_codigo}
                onChange={(e) => setRowToEdit({ ...rowToEdit, codex_codigo: e.target.value })}
              />

              <FormControl fullWidth margin="normal">
                <InputLabel id="tipo-alimento-label">Tipo de alimento</InputLabel>
                <Select
                  labelId="tipo-alimento-label"
                  value={rowToEdit.tipoalimento}
                  onChange={(e) => setRowToEdit({ ...rowToEdit, tipoalimento: e.target.value })}
                >
                  <MenuItem value="ALIMENTOS DE ORIGEN VEGETAL">ALIMENTOS DE ORIGEN VEGETAL</MenuItem>
                  <MenuItem value="ALIMENTOS DE ORIGEN ANIMAL">ALIMENTOS DE ORIGEN ANIMAL</MenuItem>
                  <MenuItem value="PIENSOS E INGREDIENTES DE PIENSOS">PIENSOS E INGREDIENTES DE PIENSOS</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth margin="normal">
                <InputLabel id="tipo-residuo-label">Tipo de residuo</InputLabel>
                <Select
                  labelId="tipo-residuo-label"
                  value={rowToEdit.tiporesiduo}
                  onChange={(e) => setRowToEdit({ ...rowToEdit, tiporesiduo: e.target.value })}
                >
                  <MenuItem value="PLAGUICIDAS QUÍMICOS DE USO AGRÍCOLA">PLAGUICIDAS QUÍMICOS DE USO AGRÍCOLA</MenuItem>
                <MenuItem value="PLAGUICIDAS QUÍMICOS">PLAGUICIDAS QUÍMICOS</MenuItem>
                <MenuItem value="CRITERIOS MICROBIOLOGICOS">CRITERIOS MICROBIOLOGICOS</MenuItem>
                <MenuItem value="METALES PESADOS">METALES PESADOS</MenuItem>
                <MenuItem value="MICOTOXINAS">MICOTOXINAS</MenuItem>
                <MenuItem value="MEDICAMENTOS VETERINARIOS">MEDICAMENTOS VETERINARIOS</MenuItem>
                </Select>
              </FormControl>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditDialogOpen(false)}>Cancelar</Button>
          <Button onClick={handleEdit} color="primary">Guardar</Button>
        </DialogActions>
      </Dialog>





      <Dialog open={deleteGroupOpen} onClose={() => setDeleteGroupOpen(false)}>
  <DialogTitle>Confirmar eliminación en grupo</DialogTitle>
  <DialogContent>
    <DialogContentText>
      ¿Está seguro que desea eliminar <strong>{seleccionados.length} registros</strong> seleccionados? Esta acción no se puede deshacer.
    </DialogContentText>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setDeleteGroupOpen(false)}>Cancelar</Button>
    <Button onClick={handleDeleteGroup} color="error" variant="contained">
      Eliminar {seleccionados.length} registros
    </Button>
  </DialogActions>
</Dialog>






    </Container>
  );
}
